module.exports = __webpack_public_path__ + "img/race-20-20.1c56889.jpg";